import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import cn from "classnames";

import { aspectRatio as ar } from "../../../../../../../../common/parameters";

import Icon from "../../../../../../../icon";
import { generatePath } from "../../../../../../../paths";

import Frame from "../../../../../Frame";
import Draggable from "../../../../../../Draggable";

import { PlayBtn, Label } from "../../../../common-style";

import { Drag, ScoreWrapper, Drop, Score } from "../../../style";

import { getImageDimensions, IGetImageDimensionsThis } from "../methods";

import { StyledLayout } from "./styles";
import messages from "./messages";
import { IProps, IState } from "./interfaces";
import { IBarsortingDrag } from "../../../../../../../../common/types";
import { convertToNewColors } from "../../../../../../../utils/convertToNewColors";

class Layout extends Component<IProps, IState> {
    size?: HTMLDivElement;
    img?: HTMLImageElement;
    state: IState = {
        width: 0,
        height: 0,
        zoom: 1,
        drops: [],
        drags: [],
        zIndex: [],
        frameScale: 1,
    };

    max_zIndex = 1;

    componentDidMount() {
        this.forceUpdate();
        window.addEventListener("resize", this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize = () => {
        setTimeout(this.imageLoaded, 100);
    };

    imageLoaded = () => {
        const { taskIndex, task, editTask } = this.props;
        const data = { ...task.data };

        const { width, zoom } = getImageDimensions.call(this as unknown as IGetImageDimensionsThis);

        let zIndex: number[] = [];

        let top: number = 0, left: number = 0, scale: number = 0;
        if (data.scorePosition) {
            top = data.scorePosition.top;
            left = data.scorePosition.left;
        }
        if (data.scale) {
            scale = data.scale;
        }

        let drops: IBarsortingDrag[] = [];
        data.bars!.forEach((barlines, index) => {
            barlines.forEach((barline, barlineIndex) => {
                if (data.nonBars![index].indexOf(barlineIndex) === -1) {
                    drops.push({
                        t: top + data.systems!.starts[index] * scale,
                        l: left + (barlineIndex === 0 ? 0 : barlines[barlineIndex - 1]) * scale,
                        w: Math.ceil((barline - (barlineIndex === 0 ? 0 : barlines[barlineIndex - 1])) * scale),
                        h: Math.ceil(data.systems!.height * scale),
                    });
                    zIndex.push(1);
                }
            });
            if (data.nonBars![index] && data.nonBars![index].indexOf(barlines.length) === -1) {
                drops.push({
                    t: top + data.systems!.starts[index] * scale,
                    l: left + (barlines[barlines.length - 1] || 0) * scale,
                    w: Math.ceil((width * zoom - (barlines[barlines.length - 1] || 0)) * scale),
                    h: Math.ceil(data.systems!.height * scale),
                });
                zIndex.push(1);
            }
        });
        let drags: IState["drags"]  = [];
        drags = JSON.parse(JSON.stringify(drops));

        if (data.drags) {
            drags!.forEach((drag, index) => {
                if (data.drags![index]) {
                    drag.l = data.drags![index].l;
                    drag.t = data.drags![index].t;
                }
            });
        }

        editTask({ taskIndex, changingProp: "drags", val: drags });

        let frameWidth = this.img!.parentElement!.parentElement!.parentElement!.getBoundingClientRect().width;
        let frameScale = frameWidth / ar.width;
        this.setState({
            width: this.img!.naturalWidth,
            height: this.img!.naturalHeight,
            drops,
            frameScale,
            zIndex,
        });
    };

    changeDragPosition = (drag: number, left: number, top: number) => {
        const { taskIndex, task, editTask } = this.props;
        const drags = [...task.data.drags!];
        if (left + drags[drag].w > ar.width) left = ar.width - drags[drag].w;
        if (top + drags[drag].h > ar.height) top = ar.height - drags[drag].h;
        drags[drag].l = Math.ceil(left);
        drags[drag].t = Math.ceil(top);
        editTask({ taskIndex, changingProp: "drags", val: drags });
    };

    savePosition = () => {
        const { task, plan, taskIndex, post } = this.props;
        const { drags } = task.data;
        post("score-editor-drags", {
            planId: plan._id,
            index: taskIndex,
            drags,
        });
    };

    render() {
        const data = this.props.task.data;
        const { width, height, drops, frameScale, zIndex } = this.state;
        const {
            color,
            scale,
            scorePosition,
            drags,
            score,
        } = data;
        const { top, left } = scorePosition!;
        return (
            <StyledLayout ref={size => { this.size = size!; }}>
                {this.size !== undefined && (
                    <Frame parent={this.size} fixed>
                        <ScoreWrapper
                            isLow={false}
                            style={{
                                left,
                                top,
                                transform: `scale(${scale}, ${scale})`,
                            }}
                        >
                            <Score style={{}}>
                                <img
                                    src={generatePath(data.score!)}
                                    ref={img => { this.img = img!; }}
                                    onLoad={this.imageLoaded}
                                    width={width}
                                    height={height}
                                    alt="score"
                                />
                            </Score>
                        </ScoreWrapper>
                        {!!width &&
                            !!height &&
                            drops!.map((drop, index) => (
                                <Drop
                                    key={index}
                                    style={{
                                        top: drop.t,
                                        left: drop.l,
                                        width: drop.w,
                                        height: drop.h,
                                    }}
                                />
                            ))}
                        {!!width &&
                            !!height &&
                            drags!.map((drag, index) => (
                                <Draggable
                                    key={index}
                                    position={{
                                        x: drag.l,
                                        y: drag.t,
                                    }}
                                    scale={frameScale}
                                    onDrag={(left, top) => this.changeDragPosition(index, left, top)}
                                    onStop={this.savePosition}
                                    onStart={() => {
                                        this.max_zIndex++;
                                        zIndex[index] = this.max_zIndex;
                                        this.setState({ zIndex });
                                    }}
                                    zIndex={zIndex[index]}
                                >
                                    <Drag
                                        style={{
                                            width: drag.w,
                                            height: drag.h,
                                            backgroundColor: convertToNewColors(color),
                                            boxShadow: "0 0 3px 2px " + convertToNewColors(color),
                                        }}
                                    >
                                        <img
                                            src={generatePath(score!)}
                                            ref={img => { this.img = img!; }}
                                            width={width * scale!}
                                            height={height * scale!}
                                            alt="drag"
                                            style={{
                                                marginLeft: -drops![index].l + left,
                                                marginTop: -drops![index].t + top,
                                            }}
                                        />
                                    </Drag>
                                </Draggable>
                            ))}
                        <PlayBtn className={cn("button", "button--play")} disabled>
                            <Icon i="play" />
                            <Label>
                                <FormattedMessage {...messages.play} />
                            </Label>
                        </PlayBtn>
                    </Frame>
                )}
            </StyledLayout>
        );
    }
}

export default Layout;
